/* eslint-disable @typescript-eslint/no-throw-literal */
import { GetStaticPaths, GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getPopularListingSlugs } from 'app/services/Api/listing'
import { listingKeys } from 'app/services/Query/listing/listing.keys'
import { listingConfig } from 'app/services/Query/listing/listing.query'
import { NextPage } from 'app/types/decalarations/next'
import { LISTING_STATUS } from 'app/utils/constants/status.constants'

import MainLayout from '~/components/layouts/MainLayout'
import ListingView from '~/views/ListingView'

const ListingPage: NextPage = () => <ListingView />

ListingPage.getLayout = (page: ReactElement) => <MainLayout>{page}</MainLayout>

export const getStaticPaths: GetStaticPaths = async () => {
  const { slugs } = await getPopularListingSlugs()

  const paths = slugs?.map((slug) => ({ params: { slug } }))

  return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const slug = context.params?.slug as string

  try {
    const queryClient = new QueryClient()
    const keyQuery = listingKeys.getListing(slug)

    await queryClient.prefetchQuery(keyQuery, listingConfig.getListing.request)

    const state = queryClient.getQueryState<ListingModel>(keyQuery)

    if (state?.status === 'error') throw state?.error

    const isSold = state?.data?.status === LISTING_STATUS.sold_out

    if (isSold) {
      await queryClient.prefetchQuery(
        listingKeys.getSimilarListings(String(state?.data?.id)),
        listingConfig.getSimilarListings.request
      )
    }

    return {
      props: {
        dehydratedState: dehydrate(queryClient)
      }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default ListingPage
